import { MCard, MGrid, MSpinner } from "components/Shared";
import { InternetUserListDto } from "interfaces/Mueller.Business.Models";
import React, { useEffect, useRef, useState } from "react";
import { TextField, Button } from "react-md";
import { getUserListWithSearch } from "requests/internetUsers";

interface Props {
  onInternetUserSelected: (user: InternetUserListDto) => any,
}

const InternetUserSearch = (props: Props) => {

  const [searchedInternetUsers, setSearchedInternetUsers] = useState<InternetUserListDto[]>(null);
  const [selectedInternetUser, setSelectedInternetUser] = useState<InternetUserListDto>(null);
  const [searchTerm, setSearchTerm] = useState<string | number>(null);
  const [isSearchingUsers, setIsSearchingUsers] = useState<boolean>(false);

  const mounted = useRef<boolean>(true);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  const colDefs = [
    { key: "internetuserid", dataSource: "internetUserId", name: "Internet User Id" },
    { key: "username", dataSource: "username", name: "Username" },
    { key: "email", dataSource: "email", name: "Email Address" },
  ];

  const onUserFetchSuccess = (users: InternetUserListDto[]) => {
      let activeUsers = users.filter((u) => u.isDisabled === false);
      setSearchedInternetUsers(activeUsers);
      setIsSearchingUsers(false);
  };

  const onSearch = () => {
    setIsSearchingUsers(true);
    getUserListWithSearch(searchTerm, onUserFetchSuccess, mounted);
  };

  return (<>
    <div className="internet-user-search">
      {selectedInternetUser ?
        <>
          <MCard
            title="Internet User Information"
            fields={[
              { label: "Internet User Id", value: selectedInternetUser.internetUserId },
              { label: "Username", value: selectedInternetUser.username },
              { label: "Email", value: selectedInternetUser.email },
            ]} />
          <div className="select-internetuser-result-buttons">
            <Button primary raised onClick={() => setSelectedInternetUser(null)}>Back</Button>
            <Button primary raised onClick={() => props.onInternetUserSelected(selectedInternetUser)}>Select</Button>
          </div>
        </>
        :
        <div className="internetuser-search">
          <div className="search-controls">
            <TextField label="Search Text" onChange={(term) => setSearchTerm(term)} />
            <Button primary raised iconEl={<i className="md-icon material-icons">search</i>} onClick={() => onSearch()} />
          </div>
          {isSearchingUsers ?
            <MSpinner />
            :
            searchedInternetUsers &&
            <MGrid
              columnDefinitions={colDefs}
              data={searchedInternetUsers}
              onRowClick={i => setSelectedInternetUser(searchedInternetUsers[i])}
            />}
        </div>
      }
    </div>

  </>);
};

export default InternetUserSearch;